import React from "react";
import {
    FaGraduationCap,
    FaLaptopCode,
    FaProjectDiagram,
    FaUserTie,
    FaRocket,
} from "react-icons/fa";
import { MdWork, MdStarRate } from "react-icons/md";
// import "./Roadmap.css"; // 👈 Make sure to create this CSS file

const roadmap = [
    {
        icon: <FaGraduationCap />,
        year: "2018 - 2021",
        description: "Bachelor’s Degree in Computer Applications (BCA).",
    },
    {
        icon: <FaLaptopCode />,
        year: "May 2020",
        description: "Started software development career as Intern at IBVL.",
    },
    {
        icon: <MdWork />,
        year: "May 2020 – July 2023",
        description: "Software Developer at IBVL. Built PHP/MySQL systems, led automation, and improved ops by 40%.",
    },
    {
        icon: <MdWork />,
        year: "Dec 2023 – May 2024",
        description: "Full Stack Developer at Digi Lateral. Built apps & WhatsApp bots.",
    },
    {
        icon: <MdWork />,
        year: "June 2024 – Dec 2024",
        description: "Sr. Backend Developer at Meizo Infotech. Optimized REST APIs and database.",
    },
    {
        icon: <FaUserTie />,
        year: "Dec 2024 – Present",
        description: "Sr. Software Developer at S Infinite Express. Led full-stack logistics solutions.",
    },
    {
        icon: <MdStarRate />,
        year: "2023 – Present",
        description: "Contributed to open-source projects and GitHub community.",
    },
    {
        icon: <FaGraduationCap />,
        year: "June 2025 - Present",
        description: "Pursuing MCA in Artificial Intelligence & Machine Learning at Amity University.",
    },
    {
        icon: <FaRocket />,
        year: "Future",
        description: "Looking forward to taking on leadership roles and building scalable, impactful software products.",
    },
];

function Roadmap() {
    return (
        <div className="roadmap-container">
            <div className="timeline">
                {roadmap.map((item, idx) => (
                    <div
                        className={`timeline-item ${idx % 2 === 0 ? "left" : "right"}`}
                        key={idx}
                    >
                        <div className="timeline-icon">{item.icon}</div>
                        <div className="timeline-content">
                            <div className="timeline-year">{item.year}</div>
                            <div className="timeline-desc">{item.description}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Roadmap;
